// The RBP links page's route, and the state a card hands it.

export const RBP_LINKS_ROUTE = '/products/:sku/rbp-links';

/** The links page of `sku`; the code is a path segment, never a query value (DF-02). */
export function rbpLinksHref(sku: string): string {
  return `/products/${encodeURIComponent(sku)}/rbp-links`;
}

/** What a card passes in router state, so the heading shows before the read lands. */
export interface RbpLinksHandover {
  readonly parentName: string;
}
